import React, { useState } from 'react';
import supabase from '../supabase/supabase';
import './crm.css';

export default function ReviewPage() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [name, setName] = useState('');
  const [rating, setRating] = useState(5);
  const [body, setBody] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setMessage('');
    try {
      const { data, error } = await supabase.functions.invoke('submit-customer-review', {
        body: { token, name: name.trim(), rating: Number(rating), body: body.trim() }
      });
      if (error || data?.error) throw new Error(data?.error || error.message);
      setMessage('Thank you! Your review was submitted for approval.');
      setBody('');
    } catch (failure) {
      setMessage(`Review not submitted: ${failure.message}`);
    } finally {
      setBusy(false);
    }
  }

  return <div className="crm-auth"><div className="crm-auth-card"><span className="crm-kicker">OTTERWORKS ENGINEERING</span><h1>Share your experience.</h1><p>Your feedback helps us do better. Reviews appear publicly only after approval.</p>
    <form onSubmit={submit}><label>Your name<input required maxLength="120" value={name} onChange={(event) => setName(event.target.value)} /></label><label>Rating<select value={rating} onChange={(event) => setRating(event.target.value)}>{[5, 4, 3, 2, 1].map((value) => <option key={value} value={value}>{value} star{value !== 1 ? 's' : ''}</option>)}</select></label><label>Your review<textarea required minLength="10" maxLength="2000" rows="5" value={body} onChange={(event) => setBody(event.target.value)} /></label><button disabled={busy} type="submit">{busy ? 'Submitting…' : 'Submit review'}</button></form>
    {message && <p role="status">{message}</p>}<a href="/">← Back to website</a>
  </div></div>;
}